import http from '@/api/http'

const REQUEST_URL = '/tel/'

export default {
  /**
   * 着信中チェック
   */
  checkIncomingCall(params): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'check_incoming_call',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 発信
   */
  makeCall(params): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'call',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 応答
   */
  answer(params): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'answer',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 通話開始
   */
  report(params): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'report',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 通話中通知
   */
  notifyTakingReport(params): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'talking_report',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 通話終了
   */
  endCall(params): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'end',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * opentok でチャットの送信
   */
  chat(params): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'chat',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  }
}
